import * as React from "react";
import { Input } from "~/components/ui/input";
import { useDebouncedState } from "~/utils/useDebouncedInput";
import { FilterMetadata } from "../../types";

// // // //

export function StringValueInput(props: {
    value: string;
    filterMetadata: FilterMetadata;
    onChange: (updatedValue: string) => void;
}) {
    const { filterMetadata } = props;

    const [value, onChange] = useDebouncedState<string>({
        debounceTimeout: 800,
        value: props.value,
        onChange: props.onChange,
    });

    return (
        <Input
            required
            value={value as string}
            placeholder={filterMetadata.content.label}
            onChange={(e) => {
                const updatedValue = e.currentTarget.value;
                onChange(updatedValue);
            }}
        />
    );
}
